import { Deserializable } from '../protocols/deserializable';
import { StatusPill } from '../shared/status-pill';
import { Address } from '../users/dto/address';
import { EmployerContact } from './employer-contact';
import { ActiveStatusPill, InactiveStatusPill } from '../shared/submission-status-pill';
import { EmployerStatusType } from '../../views/records/components/employers/ip-employers-table/models/employer-status-type';
import { EmployerStatusTypeEnum } from '../../views/records/components/employers/ip-employers-table/enum/employer-status-type-enum';
import * as moment from 'moment/moment';
import { EmployerLogo } from './employer-logo';

export class Employer implements Deserializable {
  public id!: number;
  public name!: string;
  public shortName!: string;
  public organizationCreationDate!: string;
  public entranceDate!: string;
  public craPayrollRemittanceAccountNumber!: string;
  public statusId!: number;
  public status!: EmployerStatusType;
  // Only Expandable if using Get Employer By ID
  public contacts!: EmployerContact[];
  public headOfficeAddress!: Address;
  public mailingAddress!: Address;
  public logo!: EmployerLogo | null;

  // Not from API
  public statusPill!: StatusPill;
  public formattedEntranceDate!: string;

  public onDeserialize() {
    const Deserialize = window?.injector?.Deserialize;
    if (!!this.status) {
      this.status = Deserialize?.instanceOf(EmployerStatusType, this.status);
      this.statusPill =
        this.statusId === EmployerStatusTypeEnum.Active ? new ActiveStatusPill() : new InactiveStatusPill();
    }
    if (!!this.headOfficeAddress) {
      this.headOfficeAddress = Deserialize?.instanceOf(Address, this.headOfficeAddress);
    }
    if (!!this.mailingAddress) {
      this.mailingAddress = Deserialize?.instanceOf(Address, this.mailingAddress);
    }
    if (!!this.contacts) {
      this.contacts = Deserialize?.arrayOf(EmployerContact, this.contacts);
    }
    if (this.entranceDate) {
      this.formattedEntranceDate = moment(this.entranceDate.split('T')[0]).format('MMM D, YYYY');
    }
    if (this.logo) {
      this.logo = Deserialize?.instanceOf(EmployerLogo, this.logo);
    }
  }
}
